import React from "react";

type Props = {
  htmlText: string;
};

export const FormattedHtmlText: React.FC<Props> = ({ htmlText }: Props) => {
  const parts: React.ReactNode[] = [];
  const regex = /(<\/?b>)|(<br\s*\/?>)/gi;

  let lastIndex = 0;
  let match;
  let bold = false;

  while ((match = regex.exec(htmlText)) !== null) {
    const textBefore = htmlText.slice(lastIndex, match.index);
    if (textBefore) {
      parts.push(
        bold ? <strong key={parts.length}>{textBefore}</strong> : textBefore
      );
    }

    if (match[0].toLowerCase().startsWith("<br")) {
      parts.push(<br key={parts.length} />);
    } else if (match[0] === "<b>") {
      bold = true;
    } else if (match[0] === "</b>") {
      bold = false;
    }

    lastIndex = regex.lastIndex;
  }

  const remaining = htmlText.slice(lastIndex);
  if (remaining) {
    parts.push(
      bold ? <strong key={parts.length}>{remaining}</strong> : remaining
    );
  }

  return <>{parts}</>;
};
